import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useDeletePicture() {
  const { t } = useTranslation(['account', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { deleter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const deletePicture = async (): Promise<boolean> => {
    setLoading(true)
    setError(null)
    setSuccess(null)

    try {
      await deleter(`${CONFIG.BOUNCE_API}/api/v1/profile/picture`)
      setSuccess(t('account:account.hook.picture.deleted'))
      return true
    } catch (caughtError) {
      console.error(caughtError)
      const message =
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      setError(message)
      return false
    } finally {
      setLoading(false)
    }
  }

  return { deletePicture, loading, error, success, resetState }
}
